/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PatchProductsRequestInnerAllOfSchedulesInnerDaysInner } from './PatchProductsRequestInnerAllOfSchedulesInnerDaysInner';
import {
    PatchProductsRequestInnerAllOfSchedulesInnerDaysInnerFromJSON,
    PatchProductsRequestInnerAllOfSchedulesInnerDaysInnerFromJSONTyped,
    PatchProductsRequestInnerAllOfSchedulesInnerDaysInnerToJSON,
    PatchProductsRequestInnerAllOfSchedulesInnerDaysInnerToJSONTyped,
} from './PatchProductsRequestInnerAllOfSchedulesInnerDaysInner';

/**
 * 
 * @export
 * @interface PatchProductsRequestInnerAllOfSchedulesInner
 */
export interface PatchProductsRequestInnerAllOfSchedulesInner {
    /**
     * 
     * @type {string}
     * @memberof PatchProductsRequestInnerAllOfSchedulesInner
     */
    id: string;
    /**
     * 
     * @type {Array<PatchProductsRequestInnerAllOfSchedulesInnerDaysInner>}
     * @memberof PatchProductsRequestInnerAllOfSchedulesInner
     */
    days: Array<PatchProductsRequestInnerAllOfSchedulesInnerDaysInner>;
    /**
     * 
     * @type {string}
     * @memberof PatchProductsRequestInnerAllOfSchedulesInner
     */
    hourFrom: string;
    /**
     * 
     * @type {string}
     * @memberof PatchProductsRequestInnerAllOfSchedulesInner
     */
    hourTo: string;
}

/**
 * Check if a given object implements the PatchProductsRequestInnerAllOfSchedulesInner interface.
 */
export function instanceOfPatchProductsRequestInnerAllOfSchedulesInner(value: object): value is PatchProductsRequestInnerAllOfSchedulesInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('days' in value) || value['days'] === undefined) return false;
    if (!('hourFrom' in value) || value['hourFrom'] === undefined) return false;
    if (!('hourTo' in value) || value['hourTo'] === undefined) return false;
    return true;
}

export function PatchProductsRequestInnerAllOfSchedulesInnerFromJSON(json: any): PatchProductsRequestInnerAllOfSchedulesInner {
    return PatchProductsRequestInnerAllOfSchedulesInnerFromJSONTyped(json, false);
}

export function PatchProductsRequestInnerAllOfSchedulesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchProductsRequestInnerAllOfSchedulesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'days': ((json['days'] as Array<any>).map(PatchProductsRequestInnerAllOfSchedulesInnerDaysInnerFromJSON)),
        'hourFrom': json['hourFrom'],
        'hourTo': json['hourTo'],
    };
}

export function PatchProductsRequestInnerAllOfSchedulesInnerToJSON(json: any): PatchProductsRequestInnerAllOfSchedulesInner {
    return PatchProductsRequestInnerAllOfSchedulesInnerToJSONTyped(json, false);
}

export function PatchProductsRequestInnerAllOfSchedulesInnerToJSONTyped(value?: PatchProductsRequestInnerAllOfSchedulesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'days': ((value['days'] as Array<any>).map(PatchProductsRequestInnerAllOfSchedulesInnerDaysInnerToJSON)),
        'hourFrom': value['hourFrom'],
        'hourTo': value['hourTo'],
    };
}

